export const RESET = 'EXCMCUSTOMFIELD_UPDATE_RESET'
export const SET_ERROR = 'EXCMCUSTOMFIELD_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCUSTOMFIELD_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCUSTOMFIELD_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCUSTOMFIELD_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCUSTOMFIELD_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCUSTOMFIELD_UPDATE_UPDATE_RETRIEVED'
